export default __webpack_public_path__ + "static/media/hover.569ad820.cur";